import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios' 
import Http from './api/http.js'
Vue.use(VueAxios, axios)
 
Vue.config.productionTip = false

import {Toast, Button, Tabbar, TabbarItem, Image as VanImage, Sidebar, SidebarItem, Search, Grid, GridItem, NavBar, Icon, Lazyload, Overlay, Loading, Tab, Tabs, Empty, Col, Row,Form, Field
,Divider, Area, Popup } from 'vant';
Vue.use(Button)
.use(Toast)
.use(Tabbar)
.use(TabbarItem)
.use(VanImage)
.use(Sidebar)
.use(SidebarItem)
.use(Search)
.use(Grid)
.use(GridItem)
.use(NavBar)
.use(Icon)
.use(Lazyload)
.use(Overlay)
.use(Loading)
.use(Tab)
.use(Tabs)
.use(Empty)
.use(Col)
.use(Row)
.use(Form)
.use(Field)
.use(Divider)
.use(Area)
.use(Popup)
 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
